export default __webpack_public_path__ + "static/media/d2.fa9e6151.png";